import { Component, inject } from '@angular/core';
import { MatIconRegistry, MatIconModule } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, MatIconModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  private readonly iconRegistry = inject(MatIconRegistry);
  private readonly sanitizer = inject(DomSanitizer);

  constructor() {
    this.registerIcons();
  }

  private registerIcons(): void {
    const icons = [
      { name: 'error-exclamation', path: 'icons/error-exclamation-icon.svg' },
      { name: 'hint-exclamation', path: 'icons/hint-exclamation-icon.svg' },
      { name: 'info-alert', path: 'icons/info-alert-icon.svg' },
      { name: 'info-success', path: 'icons/info-success-icon.svg' },
      { name: 'info-warning', path: 'icons/info-warning-icon.svg' },
      { name: 'success-check', path: 'icons/success-check-icon.svg' },
      { name: 'warning-exclamation', path: 'icons/warning-exclamation-icon.svg' },
      { name: 'not-content', path: 'icons/not-content.svg' },
      { name: 'not-work', path: 'icons/not-work.svg' },
      { name: 'save', path: 'icons/save-icon.svg' },
      { name: 'dont-save', path: 'icons/dont-save-icon.svg' },
      { name: 'comunicaciones-activas', path: 'icons/comunicaciones-activas-icon.svg' },
      { name: 'comunicaciones-inactivas', path: 'icons/comunicaciones-inactivas-icon.svg' },
      { name: 'total-comunicaciones', path: 'icons/total-comunicaciones-icon.svg' },
      { name: 'approved', path: 'icons/approved.svg' },
      { name: 'whatsapp', path: 'icons/whatsapp-icon.svg' },

      { name: 'HPSA', path: 'tenants/iconHPSA.svg' },
      { name: 'PVEA', path: 'tenants/iconPVEA.svg' },
      { name: 'RPLAZA', path: 'tenants/iconRPLAZA.svg' },
      { name: 'SHPSTAR', path: 'tenants/iconSHPSTAR.svg' },
      { name: 'TPSA', path: 'tenants/iconTPSA.svg' },
      { name: 'VIV', path: 'tenants/iconVIV.svg' },
      { name: 'circle', path: 'tenants/circle.svg' }
    ];

    for (const icon of icons) {
      this.iconRegistry.addSvgIcon(
        icon.name,
        this.sanitizer.bypassSecurityTrustResourceUrl(icon.path)
      );
    }
  }

  title = 'cc-irma-web';
}
